export class InventoryEntryImportModel {
  counter: number = 0;
  inventoryEntryId: number = 0;
  storeCode: number = 0;
  articleCode: number = 0;
  articleName: string = "";
  unitValue: number = 0;
  discount: number = 0;
  iva: number = 0;
  quantity: number = 0;

  constructor(
    counter: number = 0,
    inventoryEntryId: number = 0,
    storeCode: number = 0,
    articleCode: number = 0,
    articleName: string = "",
    unitValue: number = 0,
    discount: number = 0,
    iva: number = 0,
    quantity: number = 0
  ) {
    this.counter = counter;
    this.inventoryEntryId = inventoryEntryId;
    this.storeCode = storeCode;
    this.articleCode = articleCode;
    this.articleName = articleName;
    this.unitValue = unitValue;
    this.discount = discount;
    this.iva = iva;
    this.quantity = quantity;
  }
}